import {ContactsContainer} from '../containers/Documents/ContactsContainer'

export const Contacts = () => (
    <>
        <ContactsContainer />
    </>
)